import React, { useEffect, useState } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';

import OrderFilter from '../../components/orders/OrderFilter';
import OrderList from '../../components/orders/OrderList';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [orders, setOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState({ limit: 10, orderField: null, orderType: 'ASC', page: 0 });
  const blocRef = useBlocRef('orderListBloc');

  useEffect(() => {
    const searchCriteriaSub = blocRef.current.searchCriteria$.subscribe(setSearchCriteria);
    const ordersSub = blocRef.current.orders$.subscribe(setOrders);
    const totalSub = blocRef.current.total$.subscribe(setTotalOrders);
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
      searchCriteriaSub.unsubscribe();
      ordersSub.unsubscribe();
      totalSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria({ ...updatedCriteria, page: 0 });
  };

  const handleCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);
  };

  const handleOrderClick = async (order) => {
    await blocRef.current.openOrderStatusPopup(order);
  };

  return (
    <Grid container style={{ padding: '2rem' }} component={Container}>
      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <Typography variant="h4" align="left" className="page-header mb-1">
          Order Tracking
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <OrderFilter onCriteriaChange={handleFilterChange} />
      </Grid>
      <Grid item xs={12}>
        <OrderList orders={orders} searchCriteria={searchCriteria} total={totalOrders} onCriteriaChange={handleCriteriaChange} onOrderClick={handleOrderClick} />
      </Grid>
    </Grid>
  );
};
